import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import AdminLayout from "@/components/AdminLayout";
import { api } from "@/lib/api";
import { EntscheidungKarte } from "@/components/admin/EntscheidungKarte";

const TABS = [["offen", "Offen"], ["entschieden", "Entschieden"], ["verworfen", "Verworfen"]];

export default function AdminEntscheidungen() {
  const [status, setStatus] = useState("offen");
  const [data, setData] = useState({ items: [], counts: {} });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { setData((await api.get(`/admin/entscheidungen?status=${status}`)).data); } finally { setLoading(false); }
  }, [status]);
  useEffect(() => { load(); }, [load]);

  const importAudit = async () => {
    const r = await api.post("/admin/entscheidungen/import-audit");
    toast.success(`${r.data.importiert} Fälle importiert`);
    load();
  };
  const save = async (id, body) => {
    await api.post(`/admin/entscheidungen/${id}`, body);
    toast.success(body.verwerfen ? "Fall verworfen" : "Entscheidung gespeichert – wirkt ab sofort als Beispiel für die KI");
    setData((d) => ({ ...d, items: d.items.filter((i) => i.id !== id) }));
  };

  return (
    <AdminLayout>
      <div className="max-w-3xl mx-auto px-4 py-8 space-y-6" data-testid="admin-entscheidungen">
        <header className="space-y-2">
          <h1 className="text-2xl font-extrabold text-slate-900">Entscheidungs-Datenbank</h1>
          <p className="text-sm text-slate-600">Strittige Fälle der Fokustyp-Erkennung. Jede Entscheidung wird sofort Beispiel für die KI-Gegenprüfung und fester Regressionstest. Nutzer bekommen weiterhin die jeweils beste verfügbare Einschätzung.</p>
        </header>
        <div className="flex flex-wrap items-center gap-2">
          {TABS.map(([k, l]) => (
            <button key={k} type="button" onClick={() => setStatus(k)} data-testid={`entscheidungen-tab-${k}`}
              className={`rounded-full px-3 py-1 text-sm font-bold ${status === k ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-700"}`}>
              {l} ({data.counts?.[k] ?? 0})
            </button>
          ))}
          <button type="button" onClick={importAudit} data-testid="entscheidungen-import-audit"
            className="ml-auto rounded-md border border-slate-300 px-3 py-1.5 text-sm text-slate-700">Audit-Fälle importieren</button>
        </div>
        {loading ? <p className="text-sm text-slate-500">Lädt …</p> : data.items.length === 0
          ? <p className="text-sm text-slate-500" data-testid="entscheidungen-leer">Keine Fälle in dieser Ansicht.</p>
          : data.items.map((it) => <EntscheidungKarte key={it.id} item={it} onSave={save} />)}
      </div>
    </AdminLayout>
  );
}
